module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"prolongationFailed":"The last attempt to extend your subscription was unsuccessful","prolongSubscription":"Extend subscription"}}')
  delete Component.options._Ctor
}
